import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import Layout from './components/Layout';
import Login from './pages/Login';
import Splash from './pages/Splash';
import Dashboard from './pages/Dashboard';
import Vendre from './pages/Vendre';
import Sessions from './pages/Sessions';
import Historique from './pages/Historique';
import Depenses from './pages/Depenses';
import Admin from './pages/Admin';
import Onboarding from './pages/Onboarding';
import Tournoi from './pages/Tournoi';
import Depots from './pages/Depots';
import TVMode from './pages/TVMode';
import PWAInstallPrompt from './components/PWAInstallPrompt';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Splash />} />
          <Route path="/login" element={<Login />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/tv" element={<TVMode />} />
          <Route path="/app" element={<Layout />}>
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="vendre" element={<Vendre />} />
            <Route path="sessions" element={<Sessions />} />
            <Route path="historique" element={<Historique />} />
            <Route path="depenses" element={<Depenses />} />
            <Route path="tournoi" element={<Tournoi />} />
            <Route path="depots" element={<Depots />} />
            <Route path="admin" element={<Admin />} />
          </Route>
        </Routes>
        <Toaster richColors position="top-right" />
        <PWAInstallPrompt />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
